var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-normal"},[_vm._t("user"),_vm._t("title"),_c('section-tags',{attrs:{"link-info":_vm.linkInfo,"show-special-tag":""}}),_c('section-lottery',{attrs:{"link-info":_vm.linkInfo}}),_vm._t("content"),_c('section-vote',{attrs:{"link-info":_vm.linkInfo}}),_vm._t("tag")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }